import { useIntl } from 'react-intl';
import { useSWRConfig } from 'swr';
import { usePageTransitionNavigate } from '@packages/shared/src/providers/PageTransitionProvider/usePageTransition';
import { useLoginApi } from './LoginApi';

export const useLogout = () => {
  const { locale } = useIntl();
  const loginApi = useLoginApi();
  const { mutate } = useSWRConfig();
  // navigate is cross-app aware: from the order app, '/' belongs to the shopping app,
  // so it performs a full browser navigation instead of a broken client-side push.
  const push = usePageTransitionNavigate();

  const logout = async () => {
    const { apiKeyManager } = await import('@empiriecom/mybuy-session');
    if (loginApi) {
      try {
        const response = await loginApi.logout({ ecLocale: locale });
        await apiKeyManager.logout(response);
        push('/');
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e) {
        await apiKeyManager.logout();
        push('/');
      } finally {
        mutate('session');
      }
    } else {
      throw new Error('tried to access loginApi before it was initialized');
    }
  };

  return {
    logout,
  };
};
